module.exports = __webpack_public_path__ + "img/Image1@2x.c32eb6a2.png";